import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { useGetSavedPairsLazyQuery, useGetSavedTokensLazyQuery } from 'app/generated/graphql';
import Section from 'app/components/common/Section';
import SavedPairsTable from 'app/components/tables/SavedPairsTable';
import SavedTokensTable from 'app/components/tables/SavedTokensTable';
import { AppRoutes } from 'app/static/routes/routes-enum';

import s from './Saved.module.sass';

const Saved: React.FC = () => {
  const tokensFromLocalStorage: string[] = useMemo(() => (JSON.parse(localStorage.getItem('tokens') as string)), []);
  const pairsFromLocalStorage: string[] = useMemo(() => (JSON.parse(localStorage.getItem('pairs') as string)), []);

  const [fetchPairs, { data: pairs }] = useGetSavedPairsLazyQuery();
  const [fetchTokens, { data: tokens }] = useGetSavedTokensLazyQuery();

  return (
    <>
      <Helmet>
        <title>QuipuSwap Statistic - Saved Tokens/Pairs</title>
        <meta
          name="description"
          content="List with your favorite tokens and trading pairs: prices, volume, transactions, and other info."
        />
      </Helmet>

      <div className={s.root}>
        <Section head title="Saved tokens">
          {tokensFromLocalStorage && tokensFromLocalStorage.length ? (
            <SavedTokensTable
              data={tokens}
              fetch={fetchTokens}
              localStorageData={tokensFromLocalStorage}
            />
          ) : (
            <div className={s.fallbackText}>
              You haven’t saved any tokens yet. Explore more on the
              {' '}
              <Link to={AppRoutes.TOKENS} className={s.link}>
                tokens page
              </Link>
              {' '}
              or search via address.
            </div>
          )}
        </Section>

        <Section title="Saved pairs">
          {pairsFromLocalStorage && pairsFromLocalStorage.length ? (
            <SavedPairsTable
              data={pairs}
              fetch={fetchPairs}
              localStorageData={pairsFromLocalStorage}
            />
          ) : (
            <div className={s.fallbackText}>
              You haven’t saved any pairs yet. Explore more on the
              {' '}
              <Link to={AppRoutes.PAIRS} className={s.link}>
                pairs page
              </Link>
              {' '}
              or search via address.
            </div>
          )}
        </Section>
      </div>
    </>
  );
};

export default Saved;
